import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/co-to-jest-kakobuy-spreadsheet", element: <ArticlePage /> },
  { path: "/jak-zamawiac-kakobuy", element: <ArticlePage /> },
  { path: "/kakobuy-vs-pandabuy", element: <ArticlePage /> },
  { path: "/bezpieczne-zakupy-chiny", element: <ArticlePage /> },
  { path: "/darmowy-kakobuy-spreadsheet", element: <ArticlePage /> },
  { path: "/najlepsze-buty-kakobuy", element: <ArticlePage /> },
  { path: "/streetwear-kakobuy-spreadsheet", element: <ArticlePage /> },
  { path: "/czy-kakobuy-jest-bezpieczny", element: <ArticlePage /> },
  { path: "/kakobuy-finds", element: <ArticlePage /> },
  { path: "/kakobuy-links", element: <ArticlePage /> },
  { path: "/kakobuy-yupoo", element: <ArticlePage /> },
  { path: "/jak-dziala-kakobuy-spreadsheet", element: <ArticlePage /> },
  { path: "/najlepszy-agent-zakupowy-2026", element: <ArticlePage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;